import {theme} from "../theme";

export const getColorFromTheme = (color: keyof typeof theme.colors):any => {
    return (props: {theme: typeof theme }) => props.theme.colors[color]
}